export enum CreditCardType {
  AMEX = "American Express",
  DISCOVER = "Discover",
  MASTERCARD = "Mastercard",
  VISA = "Visa",
}
